import React, { useState, useEffect } from 'react';
import { fetchData } from "../../../utils/helpsers";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Box from '@mui/material/Box';
import { InlineHelpStyles } from './InlineHelp.styles';
import ErrorLog from "../ErrorLog/ErrorLog";

const InlineHelp = () => {
  const [variablesGroup, setVariablesGroup] = useState([]);
  const [variableDefinition, setVariableDefinition] = useState(null);
  // Error fetch hook
  const [error, setError] = useState(null);

  // User environment.
  const env = process.env.NODE_ENV;

  // Option 5: Wait for token before fetching data - prevents 401 errors on initial load
  useEffect(() => {
    const fetchController = new AbortController();

    // Only fetch if token is available in localStorage
    const token = window.localStorage.getItem('token');
    if (!token) {
      // Token not ready yet, wait for next render when it's available
      return;
    }

    fetchData({
      endpoint: `${process.env.REACT_APP_API_URL}/historical_variable?order=human_name.asc`,
      controller: fetchController
    }).then( response => {
      let data = response.data;
      if(Array.isArray(data)) {
        setVariablesGroup(
          data.filter(elem => elem.var_type !== "Cancelled").map((elem) => ({
            value: elem.id,
            label: elem.human_name,
            description: elem.description,
          }))
        )
      } else {
        setError({type: 'Data Error', message: `Invalid type data type ${data}, expected an object`})
      }
    }).catch(error => setError({type: 'Fetch Error', ...error}))

    // Cleaning component.
    return function cleanup() {
      fetchController?.abort("Unmounted Inline help component");
    }
  }, []);

  const getDefinition = (varID) => variablesGroup.filter(elem => {
    return elem.value === varID && setVariableDefinition(
      elem.description ? elem.description : "Not definition available"
    );
  });


  return (
    error
      ? <ErrorLog errorInfo={error} component={'InlineHelp'} environment={env}/>
      : (
        <Box sx={InlineHelpStyles}>
          <div className="inline-help">
            <Autocomplete
                id="inline-help-select"
                className={"inline-help__select"}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                options={variablesGroup}
                fullWidth={true}
                noOptionsText={'Loading...'}
                onChange={(event, newValue) => {
                  if (newValue) return getDefinition(newValue.value)
                  setVariableDefinition(null)
                }}
                renderInput={(params) =>
                    <TextField {...params} label={'Lookup Definitions:'} sx={{ input: { color: '#fff' } }} />
                }
            />
            {
              variableDefinition &&
              <div className="inline-help__definition">
                {variableDefinition}
              </div>
            }
          </div>
        </Box>
      )
  )
}

export default React.memo(InlineHelp);
